module.exports = __webpack_public_path__ + "media/Loops 110 Drums.36054384.wav";